<h2>INTRODUCTION</h2>
<p>
  By logging on to the Timechef website/application (hereinafter the “Timechef Site” or the “Site”), the user (“User”) fully and unreservedly agrees to be bound
  by these Terms and Conditions of Use (hereinafter “Terms and Conditions”).
</p>
<p>
  These Terms and Conditions apply in full to all Users and it is their responsibility to read these Terms and Conditions each time they log on to the Site.
</p>
<p>
  The Site has been put on line by its publisher in order to enable Users to create and manage an “Timechef” account, which they can use to credit their canteen
  card, view their online transaction history and access online services and offerings.
</p>
<p>
  The Site’s publisher may offer other services via the Site that require Users’ prior acceptance of specific terms and conditions. In such a case, the specific
  terms and conditions concerned will be deemed to be an addition to the Terms and Conditions set out herein.
</p>
<h2>PUBLISHER/PERSON RESPONSIBLE/EDITOR-IN-CHIEF</h2>
<p>
  <span>Publisher</span>
  ELIOR RC FRANCE, a French Law <i>Société par actions simplifiées</i> with a share capital of €10,000, whose registered office is located at 9-11 Allée DE
  L’ARCHE 92032 Paris La Défense Cedex , France and which is registered with the Nanterre Trade and Companies Registry under number 750 433 930 – Phone: +33
  (0)1.71.06.70.00
</p>
<h2>Editor-in-Chief</h2>
<p>Philippe Christon</p>
<h2>HOST</h2>
<p>ELIOR DATA, Service Portails, 9-11 Allée de l’Arche 92032 Paris La Défense Cedex , France. Phone: +33 (0)1.71.06.70.00</p>
<h2>DEFINITIONS</h2>
<p>
  “Personal data” means data concerning individual persons which enables them to be directly or indirectly identified. No “sensitive” personal data (e.g.
  information related to ethnic origin, political, philosophical or religious opinions, trade union membership or lifestyle) is collected via the Site.
</p>
<p>“Information” means all of the content available on the Site (both informational and non-informational).</p>
<p>
  “Group Company(ies)” means either (i) all of the companies of the Elior group, or (ii) any one of the companies of the Elior group when it is not necessary to
  specifically identify that company. Each of the Group Companies has its own separate legal existence and personality, and consequently the use of the term
  “Group Companies” does not constitute evidence of the formation between the said companies of a grouping with joint and several liability, either with respect
  to the Users of the Site or more generally any third parties.
</p>
<p>“You” or the “User” means any visitor to the Site, irrespective of whether or not they are customers of the Site’s publisher.</p>
<h2>INTELLECTUAL PROPERTY RIGHTS</h2>
<h2>Copyright</h2>
<p>
  The Timechef Site constitutes an intellectual creation of which ELIOR RC FRANCE (an Elior Group company) is the author within the meaning of Articles L. 111.1
  et seq. of the French Intellectual Property Code.
</p>
<p>
  All of the content available on the Site, notably photographs, written text, slogans, drawings, images, icons, sound and animated sequences (with or without
  audio), as well as any and all intellectual creations integrated into the Timechef Site (notably databases and software) are owned by ELIOR RC FRANCE and/or
  Group Companies or third parties which have authorized ELIOR RC FRANCE and/or Group Companies to use them. Consequently, all of the reproduction and
  representation rights related to such content are strictly reserved, and any reproduction or representation thereof is subject to the prior express permission
  of ELIOR RC FRANCE.
</p>
<p>
  Access to the Site does not confer upon You any intellectual property rights related to the Site, which remain exclusively owned by the Site’s publisher
  and/or the Group Companies or their partners.
</p>
<p>
  Any reproduction, representation, use, adaptation or modification – by any process or on any media – of all or part of the Timechef Site without the prior
  express permission of ELIOR RC FRANCE is strictly prohibited and would constitute an offence of copyright infringement.
</p>
<h2>Trademarks</h2>
<p>The company names, brands and distinctive signs presented on the Timechef Site are protected under trademark law.</p>
<p>
  The Elior name and logo are trademarks registered by Group Companies. Other brands and trademarks that are referred to on the Site bear a capital letter and
  are generally owned by ELIOR RC FRANCE and/or other Group Companies or are licensed to be used by a Group Company, and are also protected under trademark law.
</p>
<p>Any brands or trademarks shown on the Site that are not owned by ELIOR RC FRANCE and/or Group Companies are covered by a right of use license.</p>
<p>
  Any reproduction, representation, use, adaptation or modification of any of the above-mentioned brands and trademarks without the prior express permission of
  ELIOR RC FRANCE is strictly prohibited and would constitute an offence of trademark infringement.
</p>
<h2>HYPERLINKS</h2>
<p>Hyperlinks to content contained on the Timechef Site may be created subject to the following two conditions:</p>
<p>
  - Deep linking (framing) is prohibited. Consequently no content featured on a page of the Timechef Site may be published on, transferred to or inserted into
  another website, in whole or in part, or be used to create related products.
  <br />
  - The Timechef Site must be cited as the source of the content concerned.
</p>
<h2>PERSONAL DATA PROTECTION</h2>
<p>
  Personal data provided by Users of the Site TIMECHEF for the purposes of registration, contact details, personalized services or other types of question-based
  procedures is automatically processed by ELIOR ENTREPRISES, ARPEGE, ELRES, ANSAMBLE, L’ALSACIENNE DE RESTAURATION or an another Elior Group company, which is
  data controller.
</p>
<p>
  The objectives of collecting personal data are to enable You to create and manage an Timechef account (notably so that You can credit your canteen card on
  line and obtain an electronic receipt for your purchases at the checkout), allow You to use online services (e.g. to check restaurant waiting times or view
  the menu), allow You to use ordering services online and to ensure that we can reply to your requests and/or questions and contact You and/or inform You about
  how a service is being performed, your consumption statistics, the balance of your account, custom content and the services we offer, and/or provide You with
  any other useful information.
</p>
<p>
  You can decide to not provide your personnel data however certain information requested in online forms is compulsory. If such information is not input or is
  input incorrectly, it will not be sent to data controller and You will not be able to use the services on the Timechef Site.
</p>
<p>Your consumption statistics are obtained based on data collected when You pass through the checkout of your restaurant.</p>
<p>
  The personal data which are process from the Site TIMECHEF is intended solely for the purpose of rendering Timechef services. Consequently it is only used by
  the departments of data controller and its sub-contractors as well as by any departments of any other Group Companies involved in processing the personal data
  concerned.
</p>
<p>
  The legal basis for the processing of personal data allowing You to access and manage your TIMECHEF account is Your consent. You can manage and modify at all
  moment your choice and preferences in “My Account” tab.
</p>
<p>
  The legal basis for the processing of personal data to communicate with You in general is the legitimate interest pursued by the data controller (to keep
  records up to date and study how You use services of your TIMECHEF account, to manage efficiently your request and our activity and to keep the Site up to
  date and relevant).
</p>
<p>This application and data are stored on data centers localised in France.</p>
<p>
  Personal data is stored by data controller and/or its sub-contractors and is kept securely for the duration required to achieve the end purposes for which it
  was collected, in accordance with the applicable regulations and until the closure of your account. We may keep some personal data for a longer period of time
  after the closure of your TIMECHEF account if it is necessary to fulfill our legal obligations or to prevent fraud and abuse or enforce our right.
</p>
<p>
  In compliance with the Data Protection Regulation (General Data Protection Regulation (EU) 2016/679)), You shall have the right to access, amend, limit,
  restrict or object to the processing of any of your personal data at any time and You shall have the right to data portability by sending a letter to our DPO
  to the following address: Elior Entreprises –- Service Monétique – Tour Egée 9-11 Allée DE L’ARCHE, 92032 Paris La Défense Cedex, France, or by sending an
  e-mail to : gdpr-contact&#64;eliorgroup.com.
</p>
<p>
  You have the possibility to check, complete and update the information that You have provided by accessing the "My Account" .For further information on
  personal data protection please visit the website of the French Data Protection Commission (Commission Nationale de l’Informatique et des Libertés). If you
  feel, after contacting us, that your "Data Processing and Liberties" rights are not respected, you can address a complaint to the CNIL.
</p>
<h2>Location data</h2>
<p>
  When You use the Timechef Site and if You have agreed to location-based services, the data controller may receive data concerning your location. Data
  controller may use this data to provide You with location-based services such as proposing Elior sites located in your vicinity. This location data is not
  kept by data controller after the User has logged off from the Site.
</p>
<p>
  Location-based services can be deactivated on most mobile devices. Consequently, You can deactivate location-based notifications at any time by configuring
  your device as instructed in your device’s user manual.
</p>
<h2>Notifications by SMS/e-mail/Push</h2>
<p>
  When You use the Timechef Site and if You have agreed to receive notifications by SMS and/or e-mail and/or Push, data controller may send You information
  concerning your account balance, confirmations of your online payments, custom content and any other useful information relating to your restaurant account or
  services we offer, and/or provide You.
</p>
<p>Your personal data will not be used for sending any messages from commercial partners without your prior consent.</p>
<p>Notifications by SMS and/or e-mail may be activated or deactivated at any time via the “My Account” section of the Site.</p>
<h2>COOKIES</h2>
<p>
  Cookies are small text files that are placed onto your computer's hard drive by websites that You visit. We use cookies to collect information about how
  visitors use the Site (e.g. pages visited, the date and time of visits, etc.).
</p>
<p>
  You can refuse cookies by modifying the settings of your web browser. You can also delete some or all cookies at any time. To do so, please refer to the user
  manual for your computer.
</p>
<h2>ALLERGENS</h2>
<p>
  Our information on allergens concerns exclusively the 14 major allergens as described in European regulation that we voluntarily introduced into our meals. In
  our kitchens, all or part of these allergens are present. Also, despite all our precautions, we can not exclude the accidental cross-contamination between
  meals.
</p>
<p>The current display of allergens is made on the basis of the information communicated by our suppliers on their own products.</p>
<p>
  The information on allergens is given for information purposes only. The labeling information that are authentic and reliable are those displayed in your
  restaurant. Please check the labelling information displayed in your restaurant.
</p>

<h2>LIMITATION OF LIABILITY</h2>
<p>The content of the Timechef Site is provided for information purposes only and does not constitute any form of contractual documentation.</p>
<p>Users acknowledge that the use of or reliance on any information published on the Site is entirely at their own risk.</p>
<p>
  Neither ELIOR RC FRANCE nor any other Group Company may be held liable for:
  <br />
  - Any error, inaccuracy or omission related to the information provided on the Timechef Site.
  <br />
  - Any direct and/or indirect loss or damage, irrespective of the cause, origin, nature or consequences thereof, caused by accessing the Timechef Site or by
  any inability to access the Site.
  <br />
  - Any direct and/or indirect damage to any equipment, or any loss of data and/or financial loss, that may arise as a result of accessing the Timechef Site or
  using information obtained from the Site.
</p>
<p>
  ELIOR RC FRANCE does not accept any form of liability with respect to the content of any websites to which links may be provided on the Timechef Site. Such
  links are proposed as a service and You are solely responsible for deciding whether or not to use them.
</p>
<p>
  ELIOR RC FRANCE reserves the right to amend, correct or delete any content on the Timechef Site and/or these Terms and Conditions, at any time and without
  notice. Any amendments or updates to these Terms and Conditions will be binding on Users as soon as they are published on line.
</p>
<p>It is the responsibility of each User to take all necessary measures to ensure that their equipment, data and software are adequately protected.</p>
<h2>GOVERNING LAW AND DISPUTE RESOLUTION</h2>
<p>These Terms and Conditions are subject to French law.</p>
<p>Any Users accessing the Timechef Site from countries other than France must ensure that they comply with the laws applicable in those countries.</p>
<p>
  Any disputes relating to the interpretation and/or application of these Terms and Conditions shall be referred to the competent courts in Versailles, France.
</p>
